import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {NGXLogger} from 'ngx-logger';
import {UsageListPayload, UsageListResponse} from './usage.models';
import {environment} from '../../../../../../../../environments';

@Injectable({
  providedIn: 'root'
})
export class UsageDataService {

  constructor(private http: HttpClient, private logger: NGXLogger) {
  }

  load(): Observable<UsageListPayload> {
    return this.http.get<UsageListResponse>(`${environment.api}/usages`).pipe(
      map((res) => ({items: res.datalist, rows: res.rows}))
    );
  }
}
